/**
 * Comprehensive Accessibility Fixes
 * Handles various WCAG 2.1 compliance issues dynamically
 */

(function() {
  'use strict';

  var AccessibilityFixes = {
    
    /**
     * Fix 1: Remove empty headings
     */
    fixEmptyHeadings: function() {
      var headings = document.querySelectorAll('h1, h2, h3, h4, h5, h6');
      var fixed = 0;
      
      Array.prototype.forEach.call(headings, function(heading) {
        var text = heading.textContent.trim();
        var hasImage = heading.querySelector('img[alt]');
        var hasIcon = heading.querySelector('[aria-label]');
        
        // If completely empty and no accessible content
        if (!text && !hasImage && !hasIcon) {
          // Hide from accessibility tree
          heading.setAttribute('aria-hidden', 'true');
          heading.setAttribute('role', 'presentation');
          fixed++;
        }
      });
      
      if (fixed > 0) {
        console.log('♿ Fixed ' + fixed + ' empty headings');
      }
    },

    /**
     * Fix 2: Add accessible names to icon-only buttons
     */
    fixIconOnlyButtons: function() {
      var buttons = document.querySelectorAll('button, [role="button"]');
      var fixed = 0;
      
      Array.prototype.forEach.call(buttons, function(button) {
        // Skip if already has label
        if (button.getAttribute('aria-label') || button.getAttribute('aria-labelledby')) {
          return;
        }
        
        var text = button.textContent.trim();
        var icon = button.querySelector('[class*="icon"], [class*="Icon"], svg');
        
        // If has icon but no visible text
        if (icon && text.length < 3) {
          var label = '';
          
          // Try to derive label from context
          if (button.classList.contains('close') || button.classList.contains('Close')) {
            label = 'Close';
          } else if (button.classList.contains('search') || button.classList.contains('Search')) {
            label = 'Search';
          } else if (button.classList.contains('menu') || button.classList.contains('Menu')) {
            label = 'Menu';
          } else if (button.classList.contains('cart') || button.classList.contains('Cart')) {
            label = 'Cart';
          } else if (button.textContent.includes('×')) {
            label = 'Close';
          }
          
          if (label) {
            button.setAttribute('aria-label', label);
            fixed++;
          }
        }
      });
      
      if (fixed > 0) {
        console.log('♿ Added aria-label to ' + fixed + ' icon-only buttons');
      }
    },

    /**
     * Fix 3: Add accessible names to links with only images
     */
    fixImageOnlyLinks: function() {
      var links = document.querySelectorAll('a');
      var fixed = 0;
      
      Array.prototype.forEach.call(links, function(link) {
        // Skip if already has label
        if (link.getAttribute('aria-label') || link.getAttribute('aria-labelledby')) {
          return;
        }
        
        var text = link.textContent.trim();
        var img = link.querySelector('img');
        
        // If has image but no text
        if (img && text.length === 0) {
          var alt = img.getAttribute('alt');
          if (alt) {
            link.setAttribute('aria-label', alt);
            fixed++;
          }
        }
      });
      
      if (fixed > 0) {
        console.log('♿ Added aria-label to ' + fixed + ' image-only links');
      }
    },

    /**
     * Fix 4: Ensure focusable elements in aria-hidden containers are unfocusable
     */
    fixAriaHiddenFocusable: function() {
      var hiddenContainers = document.querySelectorAll('[aria-hidden="true"]');
      var fixed = 0;
      
      Array.prototype.forEach.call(hiddenContainers, function(container) {
        var focusableElements = container.querySelectorAll(
          'a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        
        Array.prototype.forEach.call(focusableElements, function(element) {
          // Store original tabindex if not already stored
          if (!element.hasAttribute('data-original-tabindex')) {
            var originalTabindex = element.getAttribute('tabindex') || '0';
            element.setAttribute('data-original-tabindex', originalTabindex);
          }
          // Make unfocusable
          element.setAttribute('tabindex', '-1');
          fixed++;
        });
      });
      
      if (fixed > 0) {
        console.log('♿ Made ' + fixed + ' elements in aria-hidden containers unfocusable');
      }
    },

    /**
     * Fix 5: Fix improperly nested interactive elements
     */
    fixNestedInteractive: function() {
      var links = document.querySelectorAll('a');
      var fixed = 0;
      
      Array.prototype.forEach.call(links, function(link) {
        // Check if link contains buttons
        var buttons = link.querySelectorAll('button, [role="button"]');
        if (buttons.length > 0) {
          // Convert button to span with role=presentation
          Array.prototype.forEach.call(buttons, function(button) {
            var span = document.createElement('span');
            span.innerHTML = button.innerHTML;
            span.className = button.className;
            span.setAttribute('role', 'presentation');
            button.parentNode.replaceChild(span, button);
            fixed++;
          });
        }
      });
      
      // Check if buttons contain links
      var buttons = document.querySelectorAll('button, [role="button"]');
      Array.prototype.forEach.call(buttons, function(button) {
        var links = button.querySelectorAll('a');
        if (links.length > 0) {
          Array.prototype.forEach.call(links, function(link) {
            var span = document.createElement('span');
            span.innerHTML = link.innerHTML;
            span.className = link.className;
            span.setAttribute('role', 'presentation');
            link.parentNode.replaceChild(span, link);
            fixed++;
          });
        }
      });
      
      if (fixed > 0) {
        console.log('♿ Fixed ' + fixed + ' improperly nested interactive elements');
      }
    },

    /**
     * Fix 6: Add titles to iframes without them
     */
    fixIframeTitles: function() {
      var iframes = document.querySelectorAll('iframe');
      var fixed = 0;
      
      Array.prototype.forEach.call(iframes, function(iframe) {
        if (!iframe.hasAttribute('title')) {
          var src = iframe.getAttribute('src') || '';
          var title = 'Embedded content';
          
          if (src.includes('youtube.com') || src.includes('youtu.be')) {
            title = 'YouTube video player';
          } else if (src.includes('vimeo.com')) {
            title = 'Vimeo video player';
          } else if (src.includes('instagram.com')) {
            title = 'Instagram embed';
          } else if (src.includes('googletagmanager')) {
            title = 'Google Tag Manager';
          } else if (src.includes('easylocator')) {
            title = 'Store locator map';
          }
          
          iframe.setAttribute('title', title);
          fixed++;
        }
      });
      
      if (fixed > 0) {
        console.log('♿ Added titles to ' + fixed + ' iframes');
      }
    },

    /**
     * Fix 7: Add labels to form controls without them
     */
    fixFormLabels: function() {
      var inputs = document.querySelectorAll('input:not([type="hidden"]), select, textarea');
      var fixed = 0;
      
      Array.prototype.forEach.call(inputs, function(input) {
        // Skip if already has label
        if (input.getAttribute('aria-label') || input.getAttribute('aria-labelledby')) {
          return;
        }
        
        // Check if there's a label element for this input
        if (input.id) {
          var label = document.querySelector('label[for="' + input.id + '"]');
          if (label) {
            return; // Has label, skip
          }
        }
        
        // Try to find placeholder
        var placeholder = input.getAttribute('placeholder');
        if (placeholder) {
          input.setAttribute('aria-label', placeholder);
          fixed++;
          return;
        }
        
        // Try to derive from type or name
        var type = input.getAttribute('type') || input.tagName.toLowerCase();
        var name = input.getAttribute('name') || '';
        
        if (name) {
          // Convert name to readable label (e.g., "email_address" -> "Email address")
          var label = name.replace(/_/g, ' ').replace(/([A-Z])/g, ' $1').trim();
          label = label.charAt(0).toUpperCase() + label.slice(1);
          input.setAttribute('aria-label', label);
          fixed++;
        } else if (type) {
          input.setAttribute('aria-label', type.charAt(0).toUpperCase() + type.slice(1));
          fixed++;
        }
      });
      
      if (fixed > 0) {
        console.log('♿ Added labels to ' + fixed + ' form controls');
      }
    },

    /**
     * Fix 8: Improve link text context
     */
    fixLinkText: function() {
      var links = document.querySelectorAll('a');
      var vagueLinkText = ['click here', 'here', 'read more', 'more', 'link'];
      var fixed = 0;
      
      Array.prototype.forEach.call(links, function(link) {
        var text = link.textContent.trim().toLowerCase();
        
        // If link has vague text and no aria-label
        if (vagueLinkText.indexOf(text) > -1 && !link.getAttribute('aria-label')) {
          // Try to find context from surrounding text
          var parent = link.parentElement;
          if (parent) {
            var context = parent.textContent.trim();
            // Get text before the link
            var beforeText = context.split(text)[0].trim();
            if (beforeText) {
              // Use last 50 chars as context
              var contextText = beforeText.slice(-50).trim() + ' ' + text;
              link.setAttribute('aria-label', contextText);
              fixed++;
            }
          }
        }
      });
      
      if (fixed > 0) {
        console.log('♿ Improved context for ' + fixed + ' vague links');
      }
    },

    /**
     * Fix 9: Fix JavaScript-only links
     */
    fixJavaScriptLinks: function() {
      var jsLinks = document.querySelectorAll('a[href^="javascript:"]');
      var fixed = 0;
      
      Array.prototype.forEach.call(jsLinks, function(link) {
        // Convert to button
        var button = document.createElement('button');
        button.type = 'button';
        button.innerHTML = link.innerHTML;
        button.className = link.className;
        
        // Copy data attributes
        for (var i = 0; i < link.attributes.length; i++) {
          var attr = link.attributes[i];
          if (attr.name.startsWith('data-') || attr.name.startsWith('aria-')) {
            button.setAttribute(attr.name, attr.value);
          }
        }
        
        // Copy onclick if exists
        if (link.onclick) {
          button.onclick = link.onclick;
        }
        
        // Add aria-label if missing
        if (!button.getAttribute('aria-label')) {
          var text = button.textContent.trim();
          if (text) {
            button.setAttribute('aria-label', text);
          }
        }
        
        link.parentNode.replaceChild(button, link);
        fixed++;
      });
      
      if (fixed > 0) {
        console.log('♿ Converted ' + fixed + ' JavaScript links to buttons');
      }
    },

    /**
     * Fix 10: Ensure page has H1 heading
     */
    ensureH1: function() {
      var h1Elements = document.querySelectorAll('h1');
      
      // If page already has H1, we're good
      if (h1Elements.length > 0) {
        return;
      }
      
      // No H1 found - try to convert the first H2 to H1
      var h2 = document.querySelector('h2');
      if (h2) {
        var h1 = document.createElement('h1');
        h1.innerHTML = h2.innerHTML;
        h1.className = h2.className;
        
        // Copy all attributes
        for (var i = 0; i < h2.attributes.length; i++) {
          var attr = h2.attributes[i];
          if (attr.name !== 'class') {
            h1.setAttribute(attr.name, attr.value);
          }
        }
        
        h2.parentNode.replaceChild(h1, h2);
        console.log('♿ Converted first H2 to H1 for proper document structure');
      } else {
        // No H2 either - check page title or create hidden H1
        var pageTitle = document.title.split('|')[0].trim() || 
                       document.title.split('-')[0].trim() || 
                       'Home';
        
        var h1 = document.createElement('h1');
        h1.textContent = pageTitle;
        h1.className = 'u-visually-hidden'; // Hide visually but keep for screen readers
        h1.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;';
        
        // Insert at beginning of main content
        var main = document.getElementById('main') || document.querySelector('main') || document.body;
        main.insertBefore(h1, main.firstChild);
        
        console.log('♿ Added visually hidden H1 with page title');
      }
    },

    /**
     * Fix 11: Add skip to main content link
     */
    addSkipLink: function() {
      // Check if skip link already exists
      var existingSkip = document.querySelector('.skip-to-content, [href="#main"]');
      if (existingSkip) {
        return;
      }
      
      var main = document.getElementById('main');
      if (!main) {
        return;
      }
      
      // Create skip link
      var skipLink = document.createElement('a');
      skipLink.href = '#main';
      skipLink.className = 'skip-to-content';
      skipLink.textContent = 'Skip to main content';
      skipLink.style.cssText = 'position:absolute;left:-9999px;z-index:999;padding:1em;background-color:#000;color:#fff;text-decoration:none;';
      
      // Show on focus
      skipLink.addEventListener('focus', function() {
        this.style.left = '0';
        this.style.top = '0';
      });
      
      skipLink.addEventListener('blur', function() {
        this.style.left = '-9999px';
      });
      
      // Insert at beginning of body
      document.body.insertBefore(skipLink, document.body.firstChild);
      
      console.log('♿ Added skip to main content link');
    },

    /**
     * Run all fixes
     */
    runAll: function() {
      console.log('%c♿ Running Accessibility Fixes...', 'color: #2196F3; font-weight: bold');
      
      this.ensureH1();
      this.fixEmptyHeadings();
      this.fixIconOnlyButtons();
      this.fixImageOnlyLinks();
      this.fixAriaHiddenFocusable();
      this.fixNestedInteractive();
      this.fixIframeTitles();
      this.fixFormLabels();
      this.fixLinkText();
      this.fixJavaScriptLinks();
      this.addSkipLink();
      
      console.log('%c♿ Accessibility fixes complete!', 'color: #4CAF50; font-weight: bold');
    }
  };

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      AccessibilityFixes.runAll();
    });
  } else {
    AccessibilityFixes.runAll();
  }

  // Re-run on dynamic content changes
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function(mutations) {
      var shouldRun = false;
      
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length > 0) {
          shouldRun = true;
          break;
        }
      }
      
      if (shouldRun) {
        // Debounce: run after 500ms of no changes
        clearTimeout(observer.timer);
        observer.timer = setTimeout(function() {
          AccessibilityFixes.runAll();
        }, 500);
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Expose globally for manual use
  window.AccessibilityFixes = AccessibilityFixes;

  console.log('%c♿ Accessibility Fixes Loaded', 'color: #2196F3; font-weight: bold');
  console.log('%cRun manually: window.AccessibilityFixes.runAll()', 'color: #666');

})();

